<template>
  <div class="justify-content-center d-flex flex-column">
    <el-image style="max-width: 250px;" :src="href" />
    <div>
      <div class="d-flex font-size-16 fw-semibold">
        <div class="">Nhắc hẹn:</div>
        <div>{{ title }}</div>
      </div>
      <div>{{ description }}</div>
    </div>

  </div>
</template>

<script>
export default {
  name: "ChatECard",
  props: ["href", "title", "description"]
};
</script>

<style scoped>

</style>